import { Service } from '@roc/feature-app-core';
import { TaskV2Type } from '@roc/feature-general-tasks';
import { LoanProcess } from '@roc/feature-utils';

const url = {
  GET_SELF_INSPECTION_IMAGES: '/api/v1/draws/getDrawPhotos',
  GET_DRAW_REQUEST: '/api/v1/draws/getRequestDraw',
  GET_LOAN_TO_DOS: '/api/v1/taskV2/getLoanTasks',
  GET_INSPECTION_DETAILS: '/api/v1/inspection/getInspectionDetails',
};

export class DrawReviewReportService extends Service {

  getDrawRequest(drawId: number) {
    return this.get(`${url.GET_DRAW_REQUEST}?drawId=${drawId}`);
  }
  getImages(loanId: number, drawId: number) {
    return this.get(`${url.GET_SELF_INSPECTION_IMAGES}?loanId=${loanId}&drawId=${drawId}`);
  }
  getLoanToDos(loanId, drawId, showAllTasks) {
    return this.get(`${url.GET_LOAN_TO_DOS}/${loanId}`, { loanProcess: LoanProcess.DRAWS, type2: TaskV2Type.DRAW_ID, typeId2: drawId, priorities: null, showAllTasks });
  }
  getInspectionDetails(inspectionId) {
    return this.get(url.GET_INSPECTION_DETAILS, { inspectionId });
  }
}
